import { useEffect } from "react"
import { useAppDispatch } from "../redux/store"

//React me exhige hacer el dispatch desde un ReactComponent
interface childsProps {
    details: any
}
const DispatchComponent: React.FC<childsProps> = ({details}) => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(details)
    },[])
    return(<></>)
} 
export default DispatchComponent